let InteractionHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../../externals/three'),
        ExpoTHREE = ___settings.externalLibraries.ExpoTHREE,
        AR = ___settings.externalLibraries.AR,
        _geometryNode = ___settings.geometryNode,
        _handlers = ___handlers;

  let that,
      _lastTouchLength = 0,
      _lastRadians = null,
      _lastHit,
      _sceneInitialized = false,
      _coordinateSystemMatrix = new THREE.Matrix4(),
      _hitWorldTransformMatrix = new THREE.Matrix4(),
      _absRotationMatrix = new THREE.Matrix4(),
      _planes, _points;

  class InteractionHandler {

    constructor() {
      that = this;

      // utility object that renders all the ARPlaneAnchors
      _planes = new ExpoTHREE.AR.Planes();
      _handlers.threeDManager.helpers.addSceneObject(_planes);

      // utility object that renders all the raw feature points
      _points = new ExpoTHREE.AR.Points();
      _handlers.threeDManager.helpers.addSceneObject(_points);
      
      _coordinateSystemMatrix.makeRotationX(-90 * (Math.PI / 180));
      _handlers.threeDManager.helpers.toggleGeometry(false);
      _handlers.threeDManager.helpers.toggleViewportObjects(false);
    }

    _updateViewportMatrix () {
      if(!_sceneInitialized) return;
      let matrix = new THREE.Matrix4();
      matrix.multiply(_hitWorldTransformMatrix);
      matrix.multiply(_absRotationMatrix);
      matrix.multiply(_coordinateSystemMatrix);
      _handlers.threeDManager.api.resetTransformation();
      _handlers.threeDManager.api.applyTransformation(matrix);
      _handlers.renderingHandler.updateShadowMap();
    }

    ////////////
    ////////////
    //
    // InteractionHandler API
    //
    ////////////
    ////////////

    update() {
      if(!_sceneInitialized) {
        _planes.update();
        _points.update();
      }
    }

    isInitialized() {
      return _sceneInitialized;
    }

    onTouchesBegan(event) {
      let size = _handlers.renderingHandler.getSize();

      if (event.touches.length == 1) {

        // we have to null it for the case that the user starts with one finger touch and then adds another finger
        _lastRadians = null;

        let normalizedHit = {
          x: event.locationX / size.width,
          y: event.locationY / size.height,
        };
        const { hitTest } = AR.performHitTest(
          normalizedHit, AR.HitTestResultTypes.HorizontalPlane
        );
        for (let hit of hitTest) {
          _lastHit = hit;
          if (_sceneInitialized) return;
          
          const { worldTransform } = hit;
          _hitWorldTransformMatrix.fromArray(worldTransform);

          _sceneInitialized = true;
          that._updateViewportMatrix();

          _handlers.threeDManager.helpers.toggleGeometry(true);
          _handlers.threeDManager.helpers.toggleViewportObjects(true);
          _handlers.threeDManager.helpers.removeSceneObject(_planes);
          _handlers.threeDManager.helpers.removeSceneObject(_points);  
        }

      } else if (event.touches.length == 2) {
        let normalizedHit0 = {
          x: event.touches[0].locationX / size.width,
          y: event.touches[0].locationY / size.height,
        };
        let normalizedHit1 = {
          x: event.touches[1].locationX / size.width,
          y: event.touches[1].locationY / size.height,
        };

        var dx = normalizedHit1.x - normalizedHit0.x;
        var dy = normalizedHit1.y - normalizedHit0.y;

        // angle in radians
        _lastRadians = Math.atan2(dy, dx);
      }
    }

    onTouchesMoved(event) {
      let size = _handlers.renderingHandler.getSize();
      if (event.touches.length == 1) { // one touch = move
        if (_lastTouchLength == 2) {
          // ignore single touch after dual touch
          return;
        }
        let normalizedHit = {
          x: event.locationX / size.width,
          y: event.locationY / size.height,
        };
        const { hitTest } = AR.performHitTest(
          normalizedHit, AR.HitTestResultTypes.HorizontalPlane
        );
        for (let hit of hitTest) {

          var { worldTransform } = _lastHit;
          var lastWorldTransformMatrix = new THREE.Matrix4();
          lastWorldTransformMatrix.fromArray(worldTransform);

          var { worldTransform } = hit;
          var worldTransformMatrix = new THREE.Matrix4();
          worldTransformMatrix.fromArray(worldTransform);

          var vec = new THREE.Vector3();
          vec.setFromMatrixPosition(lastWorldTransformMatrix);
          var vec2 = new THREE.Vector3();
          vec2.setFromMatrixPosition(worldTransformMatrix);
          var deltaVector = vec2.sub(vec);

          // only move in x/y space
          let deltaTransformMatrix = new THREE.Matrix4();
          deltaTransformMatrix.makeTranslation(deltaVector.x, 0, deltaVector.z);
          _hitWorldTransformMatrix.multiply(deltaTransformMatrix);
          that._updateViewportMatrix();
          _lastHit = hit;
        }
      } else if (event.touches.length == 2) {
        let normalizedHit0 = {
          x: event.touches[0].locationX / size.width,
          y: event.touches[0].locationY / size.height,
        };
        let normalizedHit1 = {
          x: event.touches[1].locationX / size.width,
          y: event.touches[1].locationY / size.height,
        };

        var dx = normalizedHit1.x - normalizedHit0.x;
        var dy = normalizedHit1.y - normalizedHit0.y;

        // angle in radians
        var angleRadians = Math.atan2(dy, dx);

        if (_lastRadians === null) {
          _lastRadians = angleRadians;
        }
        var deltaRadians = (angleRadians - _lastRadians);
        _lastRadians = angleRadians;

        let deltaRotationMatrix = new THREE.Matrix4();
        deltaRotationMatrix.makeRotationY(-deltaRadians);
        _absRotationMatrix.multiply(deltaRotationMatrix);
        that._updateViewportMatrix();
      }
      _lastTouchLength = event.touches.length;
    }

    onTouchesEnded(event) {
      _lastTouchLength = 0;
    }


  }

  return new InteractionHandler();
};

module.exports = InteractionHandler;